export class RegexPattern {
  public static PHONE_PATTERN = new RegExp(/(^\s*[+]\s*(\d\s*){5,15}\s*$)|(^\s*(\d\s*){6,15}\s*$)/);
  public static XSS_PATTERN = new RegExp('^(?!.*(<[^>]+>)).*$');
  public static NAME_PATTERN = new RegExp(/^[\p{L} \-']*$/u);
  public static EMAIL_PATTERN = new RegExp(
    /^(?!.*\.\.)(?!\.)(?=\p{L}|\d)([\p{L}0-9!#$%&'*+=/?^_`{|}~.-]+)(?<!\.)@.+(\.\p{L}{2,})+$/u
  );
  public static BILLING_EMAIL_PATTERN = new RegExp(
    /(?=^[^@]{0,64}@[^@]{0,253}$)^[A-Za-z0-9!#$%&'*+\-/=?^_`{|}~]+(?:\.[A-Za-z0-9!#$%&'*+\-/=?^_`{|}~]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/u
  ); // This is the 'official' regex that Billwerk uses, plz don't change
  public static MARKANT_ID_PATTERN = new RegExp(/^M\d{6}$/);
  public static GLN_PATTERN = new RegExp(/^\d{13}$/);
  public static IBAN_PATTERN = new RegExp(/^[A-Z]{2}\d{20,34}$/);
  public static BIC_PATTERN = new RegExp(/^[A-Z0-9]{8}([A-Z0-9]{3})?$/);
  static COUNTRY_ALPHA_2_CODE = new RegExp(/^[A-Z]{2}$/);
  public static NO_WHITESPACE_PATTERN = new RegExp(/\S/m);
  public static CURRENCY_SYMBOLS = new RegExp(/\p{Sc}|€/u);
  public static MASTER_KIN = new RegExp(/^[0-9]{8}$/);

  public static PASSWORD_POLICY_MIN_LENGTH = new RegExp(/^.{13,}$/);
  public static PASSWORD_POLICY_MIN_ONE_LOWER_LETTER = new RegExp(/^(?=.*[a-z]).*$/);
  public static PASSWORD_POLICY_MIN_ONE_UPPER_LETTER = new RegExp(/^(?=.*[A-Z]).*$/);
  public static PASSWORD_POLICY_MIN_ONE_NUMBER = new RegExp(/^(?=.*\d).*$/);
}
